// extracted by mini-css-extract-plugin
export var chevron = "_gx-2";
export var dropdownItems = "_gx-0";
export var item = "_gx-1";